import React, { useState, useCallback, Fragment, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { IModalProps } from '../../store/modules/ModalsReducer';
import { Button, Grid, TextField, } from '@material-ui/core';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import GenericModal, { IGenericModalProps } from '../GenericModal/GenericModal';
import AxiosErrorHandler from 'utils/AxiosErrorHandler';
import useStyle from './style';
import AddIcon from 'components/Icons/AddIcon';
import CircleCloseIcon from 'components/Icons/CircleCloseIcon';
import { assembleiasAssessorTipoDocumento } from 'store/modules/AssembleiasAssessorActions';
import TipoDocumento from 'models/TipoDocumento';
import CategoriaDocumentosItemModal from './CategoriaDocumentosItemModal';
import { assembleiasAssessorIncluirTipoDocumento } from 'store/modules/AssembleiasAssessorActions';
import TextRange from 'utils/TextRange';
import { IReducer } from 'store/Reducer';
export interface ICategoriaDocumentosModalGenericProps extends IGenericModalProps {
  key: string;
}

export interface ICategoriaDocumentosModal extends IModalProps {
  genericProps?: ICategoriaDocumentosModalGenericProps;
}

export interface Props extends IModalProps {
  tipo: TipoDocumento;
  atualizar: Function;
}

const PERGUNTA_MAXLENGHT = 50;

export default ({ genericProps }: ICategoriaDocumentosModal) => {

  const { t } = useTranslation();
  const classes = useStyle();

  const limitText = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCategoria(TextRange(event.currentTarget.value, PERGUNTA_MAXLENGHT));
  };
  const [categoria, setCategoria] = useState<string>('');
  const [salvando, setSalvando] = useState<boolean>(false);
  const { tiposDocumento } = useSelector((state: IReducer) => state.assembleiasAssessor);
  const [loading, setLoading] = useState<boolean>(false);
  const reduxDispatch = useDispatch();

  const listTipos = useMemo<TipoDocumento[]>(() => {
    return tiposDocumento.sort((a: TipoDocumento, b: TipoDocumento): number => {
      return a.descricao > b.descricao ? 1 : -1;
    })
  }, [tiposDocumento])

  const toClose = useCallback((): void => {
    if (genericProps && genericProps.key) {
      reduxDispatch(modalsActionsClose(genericProps.key));
    }
  }, [reduxDispatch, genericProps]);

  const cancel = () => {
    toClose();
  };

  const adicionarCategoria = useMemo(() => {
    return salvando;
  }, [salvando]);

  const atualizar = useCallback(() => {
    setLoading(true);
    reduxDispatch(
      assembleiasAssessorTipoDocumento(
        () => setLoading(false),
        error => {
          setLoading(false);
          AxiosErrorHandler(error);
        }
      )
    );
  },[reduxDispatch, setLoading]);

  const toSubmmit = useCallback(() => {
    setSalvando(true);
    reduxDispatch(
      assembleiasAssessorIncluirTipoDocumento(
        {
          descricao:categoria,
          flgDeleted:false
        },
        data => {
          atualizar();
          setCategoria("");
          setSalvando(false);
        },
        error => {
          setSalvando(false);
          AxiosErrorHandler(error);
        }
      )
    )

  },[reduxDispatch, categoria, setCategoria, atualizar]);

  useEffect(() => {
    atualizar();
  }, [atualizar]);

  return (
    <GenericModal
      title={ t("CategoriasEditModal.title") }
      content={
        <form
          className={classes.form}
          onSubmit={
            event => {
              event.preventDefault();
              toSubmmit();
            }
          }
        >
          <Grid container className={ classes.container }>
            <Grid item xs={12} sm={7} className={ classes.leftHeader }>
              <TextField
                onChange={limitText}
                className={classes.textField} 
                id="input-with-icon-textfield"
                label={t('CategoriasEditModal.label')}
                value={categoria}
                inputProps={{
                  readOnly: false
                }}
              />
            </Grid>
            <Grid item xs={12} sm={5} className={ classes.rightHeader }>
              <Button
                className={ classes.textField }
                type="submit"
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                disabled={categoria.trim() === "" || adicionarCategoria}
              >
                {t('CategoriasEditModal.buttonAdd')}
              </Button>
            </Grid>
          </Grid>

          <Fragment>
            {
            listTipos &&
              listTipos.map((tipo: TipoDocumento, key: number) => {
                return (
                    <CategoriaDocumentosItemModal key={key} loading={loading} tipo={tipo} atualizar={atualizar} />
                  );
              })
          }
          </Fragment>

          <div className={classes.formFile}>
            <Grid item xs={12} className={classes.rightActionsContent}>
              <Button variant="outlined" color="primary" onClick={cancel} disabled={salvando} startIcon={<CircleCloseIcon />}>
                {t('CategoriasEditModal.butoonClose')}
              </Button>
            </Grid>
          </div>

        </form>
      }
      genericProps={{
        maxWidth: 'sm',
        onClose: !salvando ? toClose : undefined,
      }}
    />
  );
}